import React from 'react';

const months = [
  "January", "February", "March", "April", "May", "June", 
  "July", "August", "September", "October", "November", "December"
];

const AnnualCalendar = ({ year, tradeData, onMonthSelect }) => {
    const getMonthColor = (monthData) => {
      if (!monthData || Object.keys(monthData).length === 0) {
        return 'dark:bg-slate-600 border dark:border-slate-500 border-slate-700 ';
      }
      const totalPL = Object.values(monthData).reduce((sum, day) => sum + (day?.pl || 0), 0);
      if (totalPL > 0) return 'bg-green-500';
      if (totalPL < 0) return 'bg-red-500';
      return 'bg-slate-200 dark:bg-slate-800';
    };
  
    return (
      <div className="p-4 mb-4 rounded-lg dark:bg-slate-800 bg-white dark:text-white text-slate-700 ">
        <div className="grid grid-cols-4 gap-2">
          {months.map((month, index) => (
            <button
              key={month}
              className={`p-2 rounded ${getMonthColor(tradeData[index])}`}
              onClick={() => onMonthSelect(index)}
            >
              {month}
            </button>
          ))}
        </div>
      </div>
    );
  };

  export default AnnualCalendar;